/** 
 * Author: Hemant Sharma
 * Type: Reusable Component 
 * Objective: To use as Loader in multiple places 
*/ 

import React from "react";
import { useColorScheme } from "@mui/material";
import "./style.scss";

const Loader = () => {
    const { mode } = useColorScheme();

    return (
        <div>
            <div className="aonflow-loader">
                <img src={mode === "dark" ? "/img/loader-blue.svg" : "/img/loader-purple.svg"} />
            </div>
            <div className="loader-overlay"></div>
        </div>
    );
}

export default React.memo(Loader);
 